import React, { Component } from "react";
import PropTypes from 'prop-types';
import { DesktopFilterModal, FilterModal, FullScreenModal } from '../../';
import isMobile from 'is-mobile';

import './Filters.scss';

const FiltersModal = ({ onSave, handleClear, handleClose, isVisible, isFilterModalBubbleRight, modalLeft, modalBottom, children }) => {
  return isMobile() ? (
  <FullScreenModal isVisible={isVisible} handleClose={handleClose}>
    <FilterModal onSaveClick={onSave} onHandleClearFilters={handleClear}>
      {children}
    </FilterModal>
  </FullScreenModal>
  ) : (
    <DesktopFilterModal id="desktop-filter-modal" isBubbleRight={isFilterModalBubbleRight} modalBottom={modalBottom || 85} modalLeft={modalLeft || 0} isVisible={isVisible} handleClose={handleClose}>
    <FilterModal onSaveClick={onSave} onHandleClearFilters={handleClear}>
      {children}
    </FilterModal>
  </DesktopFilterModal>
  )
}

export default FiltersModal;
